export { AtnModelCardComponent as Component } from './model-card.component'
